import axios from "axios";
import { resolveApiUrl } from "../../../assets/GlobalVariables";
import { getSessionId } from "../../../services/authService";

const JSON_HDR = { "Content-Type": "application/json; charset=utf-8" };

const ADMIN_BROADCAST_TRACE =
  typeof import.meta !== "undefined" &&
  (Boolean(import.meta.env?.DEV) ||
    String(import.meta.env?.VITE_REMINDERS_BROADCAST_TRACE || "").trim() === "1");

function adminBroadcastFetchTrace(details) {
  if (!ADMIN_BROADCAST_TRACE || !details.path?.includes?.("admin-messages")) return;
  // eslint-disable-next-line no-console
  console.info("[ADMIN_BROADCAST_FETCH_TRACE]", details);
}

function remindersResolveUrl(path) {
  const suffix = path.startsWith("/") ? path : `/${path}`;
  return resolveApiUrl(`/api/reminders${suffix}`);
}

export async function buildRemindersAuth(extraHeaders = {}) {
  const raw = await getSessionId();
  const sessionID = raw ? String(raw).trim() : "";
  if (!sessionID) {
    return { sessionID: "", headers: { ...extraHeaders } };
  }
  return {
    sessionID,
    headers: {
      "X-Session-ID": sessionID,
      ...extraHeaders,
    },
  };
}

export async function remindersGet(path, params = {}) {
  const { sessionID, headers } = await buildRemindersAuth();
  const mergedParams = { ...params };
  if (sessionID) mergedParams.sessionID = sessionID;
  const url = remindersResolveUrl(path);
  adminBroadcastFetchTrace({ verb: "GET", path, url });
  return axios.get(url, {
    params: mergedParams,
    headers,
    withCredentials: true,
  });
}

export async function remindersPost(path, body = {}) {
  const { sessionID, headers } = await buildRemindersAuth(JSON_HDR);
  const url = remindersResolveUrl(path);
  adminBroadcastFetchTrace({
    verb: "POST",
    path,
    url,
    hasSessionHeader: Boolean(sessionID),
    bodyKeys: Object.keys(body || {}),
  });
  return axios.post(
    url,
    { ...body, ...(sessionID ? { sessionID } : {}) },
    { headers, withCredentials: true }
  );
}

export async function remindersPut(path, body = {}) {
  const { sessionID, headers } = await buildRemindersAuth(JSON_HDR);
  const url = remindersResolveUrl(path);
  adminBroadcastFetchTrace({
    verb: "PUT",
    path,
    url,
    hasSessionHeader: Boolean(sessionID),
    bodyKeys: Object.keys(body || {}),
  });
  return axios.put(
    url,
    { ...body, ...(sessionID ? { sessionID } : {}) },
    { headers, withCredentials: true }
  );
}

export async function remindersDelete(path) {
  const { sessionID, headers } = await buildRemindersAuth(JSON_HDR);
  const url = remindersResolveUrl(path);
  adminBroadcastFetchTrace({ verb: "DELETE", path, url, hasSessionHeader: Boolean(sessionID) });
  return axios.delete(`${url}`, {
    data: { ...(sessionID ? { sessionID } : {}) },
    headers,
    withCredentials: true,
  });
}